import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import {
  prop,
  palette,
  withProp,
  switchProp,
  theme,
  ifProp,
} from 'styled-tools'

export const getWidth = size => {
  switch (size) {
    case 'full':
      return `
      width: 100%; 
      `
    default:
      return null
  }
}

export const getHeight = size => {
  switch (size) {
    case 'large':
      return css`
        height: 40px;
        font-size: 14px;

        ${media.greaterThan('large')`
          height: 60px;
          font-size: 18px;
        `}
      `
    case 'full':
      return css`
        height: 34px;
        width: 100%;

        ${media.greaterThan('large')`
        height: 40px;
        width: 100%;
      `}
      `
    default:
      return css`
        height: 34px;

        ${media.greaterThan('large')`
          height: 40px;
        `}
      `
  }
}

const buttonMixin = css`
  border-radius: ${theme('radius.base')};
  font-size: 14px;
  font-weight: ${theme('typography.weight.bold')};
  padding: 14px 20px 15px;
  color: ${palette('white')};
  border: 1px solid transparent;
  transition: background-color ${palette('speed.base')} ease-in-out;
`

export const buttonThemePrimary = css`
  background-color: ${palette('action')};
  color: ${palette('textInverse')};

  &:hover {
    background-color: ${palette('actionHover')};
  }
`

export const buttonThemeSecondary = css`
  background-color: ${palette('black')};
  color: ${palette('white')};
`

export const buttonThemeGhost = css`
  background-color: transparent;
  color: ${palette('text')};
  border: solid 1px ${palette('border')};

  &:hover {
    background-color: ${palette('backgroundAlt')};
  }
`

export const buttonThemeText = css`
  background-color: transparent;
  color: ${palette('action')};
`

export const buttonThemeRed = css`
  background-color: ${palette('danger')};
  color: ${palette('white')};
`
export const buttonThemeGreen = css`
  background-color: ${theme('colors.green')};
  color: ${palette('white')};
`

export const Wrapper = styled.button`
  ${buttonMixin};
  width: 100%;

  ${ifProp('forceFullWidth', 'width: 100% !important;')};

  ${switchProp(
    prop('kind'),
    {
      primary: buttonThemePrimary,
      secondary: buttonThemeSecondary,
      ghost: buttonThemeGhost,
      text: buttonThemeText,
      green: buttonThemeGreen,
      red: buttonThemeRed,
    },
    buttonThemePrimary
  )}

  ${withProp('size', size => getWidth(size))};
  ${media.greaterThan('small')`
    width: initial;
  `}
`



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/atoms/HTMLButton/styled.js